export interface InterviewActivityTaskResultSettingsResInterface {
  id: number
  interviewResult: string
  activityTaskId: number
  /**
   * 是否在使用中
   */
  isUse: boolean
}

export class InterviewActivityTaskResultSettingsRes
  implements InterviewActivityTaskResultSettingsResInterface
{
  id: number
  interviewResult: string
  activityTaskId: number
  /**
   * 是否在使用中
   */
  isUse: boolean

  constructor(props: InterviewActivityTaskResultSettingsResInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      id: _id,
      interviewResult: _interviewResult,
      activityTaskId: _activityTaskId,
      isUse: _isUse,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.id = _id
    this.interviewResult = _interviewResult
    this.activityTaskId = _activityTaskId
    this.isUse = _isUse
  }
}
